module.exports = __webpack_public_path__ + "assets/GoldPi.b4875aba3f956ffd7833071be314b31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldPi.png
// module id = 771
// module chunks = 0